"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _InteractionManager_deletionInteractionHandler, _InteractionManager_drawingToolsManager, _InteractionManager_geometryMathManager, _InteractionManager_insertionInteractionHandler, _InteractionManager_interactionManagerHelper, _InteractionManager_midPointInteractionHandler, _InteractionManager_restrictionManager, _InteractionManager_viewport, _InteractionManager_controlsManager, _InteractionManager_strategy;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionManager = void 0;
const viewer_1 = require("@shapediver/viewer");
const viewer_rendering_engine_intersection_restriction_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-restriction-engine");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const ControlsManager_1 = require("../controls/ControlsManager");
const DeletionInteractionHandler_1 = require("./handlers/DeletionInteractionHandler");
const InsertionInteractionHandler_1 = require("./handlers/InsertionInteractionHandler");
const MidPointInteractionHandler_1 = require("./handlers/MidPointInteractionHandler");
const InteractionManagerHelper_1 = require("./helpers/InteractionManagerHelper");
const DesktopStrategy_1 = require("./strategies/DesktopStrategy");
const MobileStategy_1 = require("./strategies/MobileStategy");
class InteractionManager {
    // #endregion Properties (12)
    // #region Constructors (1)
    constructor(drawingToolsManager) {
        // #region Properties (12)
        _InteractionManager_deletionInteractionHandler.set(this, void 0);
        _InteractionManager_drawingToolsManager.set(this, void 0);
        _InteractionManager_geometryMathManager.set(this, void 0);
        _InteractionManager_insertionInteractionHandler.set(this, void 0);
        _InteractionManager_interactionManagerHelper.set(this, void 0);
        _InteractionManager_midPointInteractionHandler.set(this, void 0);
        _InteractionManager_restrictionManager.set(this, void 0);
        _InteractionManager_viewport.set(this, void 0);
        _InteractionManager_controlsManager.set(this, void 0);
        _InteractionManager_strategy.set(this, void 0);
        __classPrivateFieldSet(this, _InteractionManager_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _InteractionManager_viewport, drawingToolsManager.viewport, "f");
        __classPrivateFieldSet(this, _InteractionManager_geometryMathManager, __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").geometryMathManager, "f");
        const restrictionsArray = [];
        for (const restrictionId in __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").settings
            .restrictions) {
            const restriction = __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").settings.restrictions[restrictionId];
            if (!restriction.id)
                restriction.id = restrictionId;
            restrictionsArray.push(restriction);
        }
        __classPrivateFieldSet(this, _InteractionManager_restrictionManager, new viewer_rendering_engine_intersection_restriction_engine_1.RestrictionManager(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").viewport, __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").parentNode, restrictionsArray, __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").settings.visualization), "f");
        __classPrivateFieldSet(this, _InteractionManager_deletionInteractionHandler, new DeletionInteractionHandler_1.DeletionInteractionHandler(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f"), this), "f");
        __classPrivateFieldSet(this, _InteractionManager_insertionInteractionHandler, new InsertionInteractionHandler_1.InsertionInteractionHandler(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f"), this), "f");
        __classPrivateFieldSet(this, _InteractionManager_midPointInteractionHandler, new MidPointInteractionHandler_1.MidPointInteractionHandler(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f"), this), "f");
        __classPrivateFieldSet(this, _InteractionManager_interactionManagerHelper, new InteractionManagerHelper_1.InteractionManagerHelper(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f"), this), "f");
        (0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.ADDED, (e) => {
            const event = e;
            if (event.drawingToolsId !== __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").parentNode.id)
                return;
            if (event.index !== undefined) {
                this.addPoint(event.index);
            }
            else if (event.indices !== undefined) {
                event.indices.forEach((index) => this.addPoint(index));
            }
        });
        (0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.REMOVED, (e) => {
            const event = e;
            if (event.drawingToolsId !== __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").parentNode.id)
                return;
            if (event.index !== undefined) {
                this.addPoint(event.index);
            }
            else if (event.indices !== undefined) {
                event.indices.forEach((index) => this.addPoint(index));
            }
        });
        __classPrivateFieldSet(this, _InteractionManager_strategy, viewer_shared_services_1.SystemInfo.instance.isMobile
            ? new MobileStategy_1.MobileStrategy(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f"), this)
            : new DesktopStrategy_1.DesktopStrategy(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f"), this), "f");
        if (__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").settings.controls &&
            __classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").settings.controls.length > 0) {
            __classPrivateFieldSet(this, _InteractionManager_controlsManager, new ControlsManager_1.ControlsManager(__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f")), "f");
        }
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (4)
    get deletionInteractionHandler() {
        return __classPrivateFieldGet(this, _InteractionManager_deletionInteractionHandler, "f");
    }
    get insertionInteractionHandler() {
        return __classPrivateFieldGet(this, _InteractionManager_insertionInteractionHandler, "f");
    }
    get midPointInteractionHandler() {
        return __classPrivateFieldGet(this, _InteractionManager_midPointInteractionHandler, "f");
    }
    get restrictionManager() {
        return __classPrivateFieldGet(this, _InteractionManager_restrictionManager, "f");
    }
    get interactionManagerHelper() {
        return __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f");
    }
    get controlsManager() {
        return __classPrivateFieldGet(this, _InteractionManager_controlsManager, "f");
    }
    // #endregion Public Getters And Setters (4)
    // #region Public Methods (10)
    addPoint(insertionIndex) {
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").addPoint(insertionIndex);
    }
    close() {
        var _a;
        if (__classPrivateFieldGet(this, _InteractionManager_strategy, "f").cameraFreezeFlag)
            __classPrivateFieldGet(this, _InteractionManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _InteractionManager_strategy, "f").cameraFreezeFlag);
        // Use onOut() instead of hard-setting "default" so the static
        // cursor-priority sets in DesktopStrategy are cleaned up. This prevents
        // closing one drawing-tools instance from resetting the cursor while
        // another instance still has a point hovered or is dragging.
        __classPrivateFieldGet(this, _InteractionManager_strategy, "f").onOut();
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").close();
        __classPrivateFieldGet(this, _InteractionManager_restrictionManager, "f").close();
        (_a = __classPrivateFieldGet(this, _InteractionManager_controlsManager, "f")) === null || _a === void 0 ? void 0 : _a.close();
    }
    deleteSelection() {
        __classPrivateFieldGet(this, _InteractionManager_deletionInteractionHandler, "f").deleteSelection(__classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").selectedPointIndices);
    }
    onDown(event, ray) {
        if (__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").closed)
            return;
        __classPrivateFieldGet(this, _InteractionManager_strategy, "f").onDown(event, ray);
    }
    /**
     * On mouse move, move the selected point if there is one
     *
     * @param event
     * @param ray
     */
    onMove(event, ray) {
        if (__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").closed)
            return;
        __classPrivateFieldGet(this, _InteractionManager_strategy, "f").onMove(event, ray);
    }
    /**
     * On mouse up, check if a point is close to the ray and deselect it
     */
    onUp(event) {
        if (__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").closed)
            return;
        __classPrivateFieldGet(this, _InteractionManager_strategy, "f").onUp(event);
    }
    /**
     * On mouse out.
     */
    onOut() {
        if (__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").closed)
            return;
        __classPrivateFieldGet(this, _InteractionManager_strategy, "f").onOut();
    }
    removePoint(index) {
        __classPrivateFieldGet(this, _InteractionManager_interactionManagerHelper, "f").removePoint(index);
    }
    onKeyDown() {
        if (__classPrivateFieldGet(this, _InteractionManager_drawingToolsManager, "f").closed)
            return;
        __classPrivateFieldGet(this, _InteractionManager_strategy, "f").onKeyDown();
    }
}
exports.InteractionManager = InteractionManager;
_InteractionManager_deletionInteractionHandler = new WeakMap(), _InteractionManager_drawingToolsManager = new WeakMap(), _InteractionManager_geometryMathManager = new WeakMap(), _InteractionManager_insertionInteractionHandler = new WeakMap(), _InteractionManager_interactionManagerHelper = new WeakMap(), _InteractionManager_midPointInteractionHandler = new WeakMap(), _InteractionManager_restrictionManager = new WeakMap(), _InteractionManager_viewport = new WeakMap(), _InteractionManager_controlsManager = new WeakMap(), _InteractionManager_strategy = new WeakMap();
//# sourceMappingURL=InteractionManager.js.map